import Styled from "@emotion/styled";
import Theme from "../../base/theme";

export const StyledContainer = Styled.div`
    margin-bottom: ${Theme.spacing(4)};
`;
